import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getProfile, updateProfile } from '@/api/teachers';
import type { UpdateTeacherProfileInput } from '@/types/teacher';

export function useTeacherProfile() {
  return useQuery({
    queryKey: ['teachers', 'profile'],
    queryFn: getProfile,
  });
}

export function useUpdateTeacherProfile() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: UpdateTeacherProfileInput) => updateProfile(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['teachers', 'profile'] });
    },
  });
}
